import { StyleShadowRoot } from "@redotech/react-util/style";
import { DeliveryEstimate as DeliveryEstimateType } from "@redotech/redo-model/conversion/conversion-autocheck";
import { IpifyGeoClientProvider } from "@redotech/redo-web/ipify";
import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { memo } from "react";
import STYLE_MANAGER from "../../style-manager";
import { DeliveryEstimate } from "./delivery-estimate";
import { useCartRenderPortals } from "./use-cart-render-portals";
import { useRenderPdps } from "./use-render-pdps";
import { ZipCodeProvider } from "./zip-code-context";

export const DeliveryEstimateInitializer = memo(
  function DeliveryEstimateInitializer({
    deliveryEstimateSettings,
  }: {
    deliveryEstimateSettings: DeliveryEstimateType;
  }) {
    const pdpPortals = useRenderPdps({
      deliveryEstimate: deliveryEstimateSettings,
    });
    const cartPortals = useCartRenderPortals({
      deliveryEstimate: deliveryEstimateSettings,
    });

    const ipifyApiKey =
      globalThis.redoStorefront?.env?.IPIFY_API_KEY ??
      process.env.IPIFY_API_KEY;
    if (!ipifyApiKey) {
      console.error("IPIFY_API_KEY is not set");
      return null;
    }

    const allPortals = [...pdpPortals, ...cartPortals];

    if (allPortals.length === 0) {
      return null;
    }

    return (
      <IpifyGeoClientProvider apiKey={ipifyApiKey}>
        <ZipCodeProvider>
          {allPortals.map(({ foundSelector, portal }, index) => (
            <StyleShadowRoot
              key={index}
              shadowRoot={portal.root}
              styleManager={STYLE_MANAGER}
            >
              <ModalRootContext.Provider value={portal.modalContainer}>
                <DeliveryEstimate
                  estimatedDeliveryDate={
                    deliveryEstimateSettings.estimatedDeliveryDate
                  }
                />
              </ModalRootContext.Provider>
            </StyleShadowRoot>
          ))}
        </ZipCodeProvider>
      </IpifyGeoClientProvider>
    );
  },
);
